module.exports = __webpack_public_path__ + "img/account-banner.de9bdd0d.png";